import _ from 'underscore';

export const modelToViewModelForAdRotation = data => ({
  AdRotation: _.get(data, ['AdRotation', 'RotationType']),
});
